<template>
  <div class="full-width">
    <q-tabs
      v-model="selectedGroupTab"
      dense
      narrow-indicator
      active-color="secondary"
    >
      <q-tab name="all" class="text-caption rounded-borders">
        当前情况
      </q-tab>
      <q-tab name="day" class="text-caption rounded-borders">
        当日情况
      </q-tab>
    </q-tabs>
    <q-tab-panels v-model="selectedGroupTab" class="bg-transparent">
      <q-tab-panel name="all">
        <q-table
          style="max-height: 500px;height: calc(100%)"
          class="full-width rounded-borders sticky-header-table shadow-none"
          :data="all_group"
          :columns="columnDef"
          :loading="loadingAllGroup"
          row-key="groupName"
          :rows-per-page-options="[0]"
          separator="cell"
          hide-bottom
        >
          <template v-slot:no-data="{ icon, message, filter }">
            <Empty />
          </template>
        </q-table>
      </q-tab-panel>
      <q-tab-panel name="day">
        <q-table
          style="max-height: 500px;height: calc(100%)"
          class="full-width rounded-borders sticky-header-table shadow-none"
          :data="day_group"
          :columns="columnDef"
          :loading="loadingDayGroup"
          row-key="groupName"
          :rows-per-page-options="[0]"
          separator="cell"
          hide-bottom
          v-if="day_group && day_group.length"
        />
        <Empty v-else />
      </q-tab-panel>
    </q-tab-panels>
  </div>
</template>

<script>
import { aggStatusOfGroupAll } from "@/api/endpoints/agg/aggStatusOfGroupAll";
import { aggStatusOfGroupDay } from "@/api/endpoints/agg/aggStatusOfGroupDay";

const sortNum = (a, b, rowA, rowB) => {
  return parseFloat(a) - parseFloat(b);
};
const sortPct = (a, b, rowA, rowB) => {
  return (
    parseFloat(a.replace(/(.*)%/, "$1")) - parseFloat(b.replace(/(.*)%/, "$1"))
  );
};

const columnDef = [
  {
    name: "小组名称",
    field: "groupName",
    label: "小组名称",
    align: "center",
    sortable: true,
  },
  {
    name: "已完成",
    field: "finished",
    label: "已完成",
    align: "center",
    sortable: true,
    sort: sortNum,
  },
  {
    name: "无效",
    field: "invalid",
    label: "无效",
    align: "center",
    sortable: true,
    sort: sortNum,
  },
  {
    name: "拒访",
    field: "rejected",
    label: "拒访",
    align: "center",
    sortable: true,
    sort: sortNum,
  },

  {
    name: "进行中",
    field: "started",
    label: "进行中",
    align: "center",
    sortable: true,
    sort: sortNum,
  },
  {
    name: "接触数量",
    field: "touch",
    label: "接触数量",
    align: "center",
    sortable: true,
    sort: sortNum,
  },
  {
    name: "完访率",
    field: "finish_pct",
    label: "完访率",
    align: "center",
    sortable: true,
    sort: sortPct,
  },
  {
    name: "拒访率",
    field: "rejected_pct",
    label: "拒访率",
    align: "center",
    sortable: true,
    sort: sortPct,
  },
  {
    name: "无效率",
    field: "invalid_pct",
    label: "无效率",
    align: "center",
    sortable: true,
    sort: sortPct,
  },
];
import AggMixin from "./agg.mixin";

export default {
  mixins: [AggMixin],
  components: {
    Loading: () => import("@/components/Loading"),
    Empty: () => import("@/components/Empty"),
  },
  data() {
    return {
      all_group: [],
      day_group: [],

      selectedGroupTab: "all",
      columnDef,
      pagination: {},
      loadingAllGroup: false,
      loadingDayGroup: false,
    };
  },

  methods: {
    agg() {
      this._aggStatusOfGroupAll();
      this._aggStatusOfGroupDay();
    },
    async _aggStatusOfGroupAll() {
      try {
        const response = await aggStatusOfGroupAll();
        if (!response || response.err || response.message)
          throw Error(response.detail || response.message);
        this.all_group = response;
      } catch (err) {
        this.$q.notify({
          type: "danger",
          message: err.toString(),
        });
      }
    },

    async _aggStatusOfGroupDay() {
      try {
        const _date = this.date;
        const d = new Date(_date);
        const year = d.getFullYear();
        const month = d.getMonth() + 1;
        const date = d.getDate();
        const response = await aggStatusOfGroupDay({ year, month, date });
        if (!response || response.err || response.message)
          throw Error(response.detail || response.message);
        this.day_group = response;
      } catch (err) {
        this.$q.notify({
          type: "danger",
          message: err.toString(),
        });
      }
    },
  },
};
</script>
